import { CompanyType, PhoneCodeChannel } from 'components/SelfRegistration/types/enums';
import { IResponse } from 'services/api/axios';

/**
 * Коды ошибок саморегистрации, приходят в `errors[].code`.
 * Сообщение из `errors[].message` уже локализовано бэкендом,
 * поэтому коды используются только там, где от них зависит поведение формы.
 */
export const SELF_REG_ERROR_CODES = {
  /** Неверный код из SMS, в сообщении указано количество оставшихся попыток */
  WRONG_CODE: 902,
  /** Попытки исчерпаны, ввод кода заблокирован на 15 минут */
  TOO_MANY_ATTEMPTS: 903,
  /** Номер уже используется в другом аккаунте */
  PHONE_TAKEN: 904,
  /** Email уже зарегистрирован */
  EMAIL_TAKEN: 905,
  /** Регистрация без подтверждённого телефона */
  PHONE_NOT_CONFIRMED: 906,
  /** Капча не пройдена, виджет нужно перерисовать */
  // CAPTCHA_FAILED: 907,
  /** Код уже отправлен, повторная отправка будет доступна позже */
  CODE_ALREADY_SENT: 908,
  /** Превышен лимит запросов кода на номер или с IP */
  RATE_LIMIT: 910,
};

/** Блокировка ввода кода после исчерпания попыток, минут */
export const CODE_LOCK_MINUTES = 15;
/** Кулдаун повторной отправки SMS-кода по умолчанию, секунд */
export const RESEND_COOLDOWN_SECONDS = 60;
/** Кулдаун повторной отправки письма со ссылкой для установки пароля, секунд */
export const EMAIL_RESEND_COOLDOWN_SECONDS = 600;

export interface IRegistrationDtoRes {
  phone: string;
  email: string
  /** UTM-метки первого захода, передаются при первой отправке кода */
  utm?: Record<string, string>;
  // captchaToken?: string;
}

export interface IPhoneCodeDto {
  expiresAt: string;
  resendAfterSeconds: number;
}

export interface IPhoneCodeResDto extends IResponse {
  data: IPhoneCodeDto;
}

export interface IPhoneCodeChannelDto {
  channel: PhoneCodeChannel;
}

export interface IPhoneCodeChannelResDto extends IResponse {
  data: IPhoneCodeChannelDto;
}

export interface IPhoneCodeConfirmBody {
  phone: string;
  code: string;
}

export interface ISelfRegistrationBody {
  companyType: CompanyType;
  name: string;
  contactPerson?: string;
  email: string;
  phone: string;
}

export interface ISelfRegistrationDto {
  email: string;
  trialEndDate: string;
}

export interface ISelfRegistrationResDto extends IResponse {
  data: ISelfRegistrationDto;
}

export interface IIndustryDto {
  id: number;
  name: string;
  active: boolean;
}

export interface IIndustryListResDto extends IResponse {
  data: IIndustryDto[];
}

export interface ITrialStatusDto {
  selfRegistered: boolean;
  trialEndDate: string;
  daysLeft: number;
  warning: boolean;
}

export interface ITrialStatusResDto extends IResponse {
  data: ITrialStatusDto;
}

export interface IAccountDetailsDto {
  fullName: string | null;
  inn: string | null;
  industryId: number | null;
  industryName: string | null;
  contactPerson: string | null;
  contactPhone: string | null;
  editable: boolean;
}

export interface IAccountDetailsResDto extends IResponse {
  data: IAccountDetailsDto;
}

export interface IAccountDetailsUpdateBody {
  inn: string | null;
  industryId: number | null;
  contactPerson: string | null;
  contactPhone: string | null;
}

/** Значения формы регистрации, телефон хранится без маски: 998901234567 */
export interface ISelfRegistrationForm {
  companyType: CompanyType;
  name: string;
  contactPerson: string;
  email: string;
  phone: string;
  // captchaToken: string;
  code: string;
}

/** Значения формы реквизитов в разделе «Моя учётная запись» */
export interface IAccountDetailsForm {
  inn: string;
  industryId: number | null;
  contactPerson: string;
  contactPhone: string;
}
